/**
 * EnumField for SchemaForm — renders a JSON-Schema property with an `enum` constraint
 * as a `<select>` of those values.
 */

import { useFormContext, type FieldValues } from 'react-hook-form';
import styles from '../SchemaForm.module.css';
import type { SchemaFieldProps } from './TextField';

export function EnumField({ name, sub, required }: SchemaFieldProps) {
  const {
    register,
    formState: { errors },
  } = useFormContext<FieldValues>();
  const error = errors[name];
  const values: readonly (string | number)[] = Array.isArray(sub.enum) ? sub.enum : [];
  return (
    <label className={styles.field}>
      <span>
        {name}
        {required ? ' *' : ''}
      </span>
      <select {...register(name, { required })} aria-label={name} defaultValue="">
        <option value="">—</option>
        {values.map((v) => (
          <option key={String(v)} value={String(v)}>
            {String(v)}
          </option>
        ))}
      </select>
      {sub.description && <small>{sub.description}</small>}
      {error && <small className={styles.error}>Required</small>}
    </label>
  );
}
